import { testDataCreator } from '@wix/answers-lib';
import { ItemType } from '../misc/item-type.enum';
export var openingHoursBuilder = testDataCreator(function () { return ({
    openTwentyFourSeven: false,
    openingHours: {
        SUNDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        MONDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        TUESDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        WEDNESDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        THURSDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        FRIDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        },
        SATURDAY: {
            dailyActivities: [{ enabled: true, end: [17, 0, 0, 0], start: [9, 0, 0, 0] }],
            enabled: true
        }
    }
}); });
export var tenantScheduleBuilder = testDataCreator(function () { return ({
    id: 'some-id',
    name: 'some-name',
    description: 'some-description',
    openingHours: openingHoursBuilder(),
    timezone: 'Etc/UTC',
    lastUpdateDate: 10000,
    creationDate: 500,
}); });
export var downTimeBuilder = testDataCreator(function () { return ({
    id: 'some-id',
    scheduleId: 'some-schedule-id',
    name: 'some-name',
    startDate: new Date(2019, 10, 27, 0, 0).valueOf(),
    endDate: new Date(2019, 10, 28, 0, 0).valueOf()
}); });
export var itemUsageBuilder = testDataCreator(function () { return ({
    itemId: 'some-id',
    itemType: ItemType.SCHEDULE,
    locale: 'en',
    relatedItemId: Math.random().toString(),
    relatedItemType: ItemType.QUEUE,
    sortOrder: 0,
    creationDate: new Date().toISOString()
}); });
export var scheduleItemUsageBuilder = testDataCreator(function () { return ({
    relatedItemName: 'some-name',
    relation: itemUsageBuilder()
}); });
export var scheduleUsageInfoBuilder = testDataCreator(function () { return ({
    RULE: [scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.RULE })
        })],
    QUEUE: [scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.QUEUE })
        })],
    LINE: [scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.LINE })
        })],
    WIDGET: [
        scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.WIDGET }),
            contactTypeUsages: [1, 2]
        }),
        scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.WIDGET }),
            contactTypeUsages: [3]
        })
    ],
    SLA_POLICY: [scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.SLA_POLICY }),
        })],
    GROUP: [
        scheduleItemUsageBuilder({
            relation: itemUsageBuilder({ relatedItemType: ItemType.GROUP }),
            activityTypeUsages: [10, 20, 30]
        }),
    ],
}); });
//# sourceMappingURL=tenant-schedule.builder.js.map